export const staleEconomicsRepairSessionKey = venueId =>
  `menuBuilderStaleEconomicsRepair:${venueId}`

export const hasStaleEconomicsRepairSession = venueId => {
  if (!venueId) return false

  try {
    return (
      sessionStorage.getItem(staleEconomicsRepairSessionKey(venueId)) === '1'
    )
  } catch {
    return false
  }
}

export const markStaleEconomicsRepairSession = venueId => {
  if (!venueId) return

  try {
    sessionStorage.setItem(staleEconomicsRepairSessionKey(venueId), '1')
  } catch {
    // sessionStorage may be unavailable in tests or private browsing
  }
}

export const clearStaleEconomicsRepairSession = venueId => {
  if (!venueId) return

  try {
    sessionStorage.removeItem(staleEconomicsRepairSessionKey(venueId))
  } catch {
    // ignore
  }
}
